import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { privateRequest } from "services/privateRequest";
import { CUSTOMER, INVITE_CUSTOMER } from "services/endPoints";
import toast from "react-hot-toast";

const initialState = {
  supportCustomerList: [],
  customerRequestsList: [],
  loading: false,
  totalCount: 0,
  error: null,
};

export const getSupportCustomerList = createAsyncThunk(
  "supportCustomer/getSupportCustomerList",
  async ({ projectId, pageNo = 1, pageSize = 25, search = "" }, { signal, rejectWithValue }) => {
    try {
      const res = await privateRequest.get(
        `/api/projects/${projectId}/customers?pageNo=${pageNo}&pageSize=${pageSize}&search=${search}`,
        { signal }
      );
      return res?.data || {};
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const inviteSupportCustomers = createAsyncThunk(
  "supportCustomer/inviteSupportCustomers",
  async ({ email, projectId }, { dispatch, rejectWithValue }) => {
    try {
      const payload = { email };
      const res = await privateRequest.post(INVITE_CUSTOMER, payload);
      dispatch(getSupportCustomerList({ projectId }));
      toast.success(res?.data.message);
      return true;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const fetchCustomerRequests = createAsyncThunk(
  "supportCustomer/fetchCustomerRequests",
  async ({ pageNo = 1, pageSize = 10, search = "" ,status ="" ,  workTypeId= "" , projectId = ""}, { signal, rejectWithValue }) => {
    try {
      const res = await privateRequest.get(`${CUSTOMER}/requests?pageNo=${pageNo}&pageSize=${pageSize}&search=${search}&status=${status}&workTypeId=${workTypeId}&projectId=${projectId}`,
        { signal }
      );
      console.log(res?.data);
      return res?.data || {};
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const supportCustomerSlice = createSlice({
  name: "supportCustomer",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSupportCustomerList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupportCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        const customers = action.payload?.data?.data || [];
        const pageNo = action.meta?.arg?.pageNo || 1;
        const shouldAppend = action.meta?.arg?.append && pageNo > 1;

        if (shouldAppend) {
          state.supportCustomerList = [
            ...(state.supportCustomerList || []),
            ...customers,
          ];
        } else {
          state.supportCustomerList = customers;
        }
        state.totalCount = action.payload?.data?.count?.total || 0;
        state.error = null;
      })
      .addCase(getSupportCustomerList.rejected, (state, action) => {
        state.loading = false;
        state.supportCustomerList = [];
        state.totalCount = 0;
        state.error = action.payload;
      })
      .addCase(inviteSupportCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(inviteSupportCustomers.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(inviteSupportCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchCustomerRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.customerRequestsList = action.payload?.data?.data || [];
        console.log(action.payload?.data?.data );
        
        state.totalCount = action.payload?.data?.count?.total || 0;
        console.log(action.payload?.data?.count?.total);
        
        state.error = null;
      })
      .addCase(fetchCustomerRequests.rejected, (state, action) => {
        state.loading = false;
        state.customerRequestsList = [];
        state.totalCount = 0;
        state.error = action.payload;
      });
  },
});

export const { clearError } = supportCustomerSlice.actions;
export default supportCustomerSlice.reducer;